import { render, staticRenderFns } from "./addprovider.vue?vue&type=template&id=4847a9ef&scoped=true&"
import script from "./addprovider.vue?vue&type=script&lang=js&"
export * from "./addprovider.vue?vue&type=script&lang=js&"
import style0 from "./addprovider.vue?vue&type=style&index=0&id=4847a9ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847a9ef",
  null
  
)

export default component.exports